import { ProductSliderSources } from "@omni/types/components/product/enums/productSliderResource.enum";
import { ControlsPosition } from "@omni/types/components/props/productSlider.props";

import { ProductSliderDefault } from "@/components/Product/ProductSlider/productSlider.default";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useProductPageContext } from "../../context/productPage.context";
import { ProductPageConfig } from "../../productPage.config";

export const RecentlyViewedProductSliderContainer = () => {
    const { t } = useGranite();
    const { product } = useProductPageContext();
    return (
        <ProductSliderDefault
            title={t("sliders.recents.title")}
            controlsPosition={ControlsPosition.Default}
            source={ProductSliderSources.Recent}
            breakpointsConfig={{
                hidden: [],
                layoutSettings: ProductPageConfig.sliders.recent
            }}
            productTileConfig={{
                amountOfFeatures: 0,
                useInsidePadding: false,
                showButton: false,
                showCategoryLink: false,
                allowInstantAddToCart: false
            }}
            sku={product.sku}
        />
    );
};
